import React from 'react'
import styled from 'styled-components'
import { CircularProgress } from '@material-ui/core'

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`

export const Spinner = () => (
  <StyledWrapper>
    <CircularProgress />
  </StyledWrapper>
)
